export default {
    methods: {
        print() {
            return {
                agendar(agendamento) {

                    const page = window.open('', Math.random())

                    const date = new Date().toLocaleString();

                    const image = page.document.createElement('img')

                    image.style.height = '30px';

                    image.src = agendamento.logotipo ? require(`@/assets/cliente/logotipo/${agendamento.logotipo}`) : null

                    let prefeitura = agendamento.nomePrefeitura ? `
                        <strong>PREFEITURA DE ${agendamento.nomePrefeitura}</strong>
                        ` : ''

                    let ramoAtividade = agendamento.ramoAtividade ? `Secretaria Municipal de ${agendamento.ramoAtividade}` : ''

                    let sistemaNome = agendamento.sistemaNome ? `${agendamento.sistemaNome}` : ''
                    let sistemaVersao = agendamento.sistemaVersao ? `${agendamento.sistemaVersao}` : ''

                    let nomeSocial = agendamento.pacienteNomeSocial ? ` (${agendamento.pacienteNomeSocial})` : ''

                    let obs = agendamento.mensagemProtocolo
                        ? `<fieldset class='atencao'><legend>Atenção</legend>${agendamento.mensagemProtocolo}</fieldset>`
                        : ''

                    page.document.write(`
                         <head>
                            <title>Pedido do Agendamento</title>

                            <style>
                                * {
                                    font-family: 'Arial', Gadget, sans-serif;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                    border-collapse: collapse;
                                }
                                body {
                                    max-width: max-content;
                                    margin: auto;
                                }
                                table.report-container {
                                    page-break-after: always;
                                }
                                thead.report-header {
                                    display: table-header-group;
                                }
                                tfoot.report-footer {
                                    display: table-footer-group;
                                    border: 0;
                                }
                                table, tbody tr, tbody td {
                                    border: 0;
                                }
                                table {
                                    width: 10.3cm;
                                    border-collapse: collapse;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 10.3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    border:  1px solid #000000;
                                }
                                #paciente {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #pedido {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #obs {
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: wrap;
                                    align-items: center;
                                    max-width: 10.3cm;
                                }
                                #obs p {
                                    margin: 0;
                                    flex: 1;
                                }
                                #left-col {
                                    flex-grow: 1;
                                }
                                #right-col {
                                    flex-grow: 1;
                                    font-size: 0.3cm;
                                    text-align: right;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.35cm;
                                    margin: 0.05cm 0;
                                    padding: 0;
                                }
                                .line {
                                   border-bottom: 1px dotted #c7c7c7;
                                   margin: 5px 0
                                }
                                .lineBottom {
                                   border-bottom: 2px solid #000000;
                                }
                                .pr-10 {
                                   padding-right: 10px;
                                }
                                .pr-10 {
                                   padding-right: 10px;
                                }
                                fieldset{
                                    width: 100%;
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    padding: 0 5px;
                                }
                                .atencao {
                                    flex-direction: column;
                                    padding: 0 5px;
                                    margin: 5px 0;
                                }
                                legend {
                                    font-family: Arial, Helvetica, sans-serif;
                                    font-size: 15px;
                                    font-weight: 100!important;
                                }
                                #viagem {
                                    display: flex;
                                    flex-wrap: wrap;
                                }
                                #acompanhante {
                                    flex-basis: 100%;
                                    border: 1px solid #000000;
                                    margin-top: 10px;
                                    padding: 5px 0 3px 0;
                                    text-align: center;
                                    font-size: 12px;
                                    min-height: 35px;
                                    box-sizing: border-box;
                                }
                                #data-inicial {
                                    border: 1px solid #000000;
                                    flex: 1;
                                    margin-top: 10px;
                                    padding: 5px 0 3px 0;
                                    text-align: center;
                                    font-size: 12px;
                                    min-height: 35px;
                                    box-sizing: border-box;
                                    margin-right: 2%;
                                }
                                #data-final {
                                    border: 1px solid #000000;
                                    flex: 1;
                                    margin-top: 10px;
                                    padding: 5px 0 3px 0;
                                    text-align: center;
                                    font-size: 12px;
                                    min-height: 35px;
                                    box-sizing: border-box;
                                }
                                #rodape-left {
                                    width: 25%;
                                    float: left;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align:  left;
                                }
                                #rodape-right {
                                    width: 75%;
                                    float: right;
                                    margin-top: 5px;
                                    font-size: 9px;
                                    text-align: right;
                                }
                                table {
                                    width: 100%;
                                }
                                tr {
                                    border: 1px solid black;
                                    border-collapse: collapse;
                                }
                                td {
                                    font-size: 13px;
                                }
                                #img {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                #prefeitura {
                                   text-align: center;
                                   padding-top: 5px;
                                   text-transform: uppercase;
                                }
                                #ramoAtividade {
                                    text-align: center;
                                    padding-bottom: 10px;
                                }
                                #prontuario {
                                    float: left;
                                    width: 30%;
                                }
                                #dataNascimento {
                                    padding-left: 5%;
                                    float: left;
                                    width: 63%;
                                }
                                #responsavel {
                                    clear:  both;
                                    width: 100%;
                                }
                                .titulo {
                                    font-size: 16px;
                                    text-align: center;
                                    padding: 10px 0 3px 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                .b-0 {
                                    border: 0;
                                }
                                #agendamentoSpan {
                                    font-size: 18px;
                                    text-align: center;
                                    font-weight: 700;
                                }
                            </style>
                        </head>

                        <body>

                            <table class="report-container">
                                <thead class="report-header">
                                    <tr class="b-0">
                                        <th class="report-header-cell">
                                            <div class="header-info">

                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot class="report-footer">
                                    <tr class="b-0">
                                        <td class="report-footer-cell">
                                            <div class="footer-info">

                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>

                                <tbody class="report-content">
                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="img"></div>
                                            <div id="prefeitura"></div>
                                            <p id="ramoAtividade"></p>
                                            <div class="lineBottom"></div>
                                            <div class="titulo"><strong>TRANSPORTE</strong></div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="paciente">
                                                <fieldset>
                                                    <legend>Dados do paciente</legend>
                                                    <div id="left-col">
                                                        <p id="pacienteNome">
                                                            <strong>Paciente:</strong><br />
                                                            ${agendamento.pacienteNome} <strong>${nomeSocial}</strong>
                                                        </p>
                                                        <p id="PacienteTelefones">
                                                            <strong>Telefones:</strong><br />
                                                            ${agendamento.pacienteTelefones}
                                                        </p>
                                                        <p id="prontuario">
                                                            <strong>Prontuário:</strong><br />
                                                            ${agendamento.prontuario}
                                                        </p>
                                                        <p id="dataNascimento">
                                                            <strong>Data nascimento:</strong><br />
                                                            ${agendamento.dataNascimento}
                                                        </p>
                                                        <p id="unidade">
                                                            <strong>Unidade:</strong><br />
                                                            ${agendamento.unidade}
                                                        </p>
                                                        <p id="unidadeTelefone">
                                                            <strong>Telefone:</strong><br />
                                                            ${agendamento.unidadeTelefone}
                                                        </p>
                                                        <p id="usuario">
                                                            <strong>Usuario:</strong><br />
                                                            ${agendamento.usuario}
                                                        </p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="pedido">
                                                <fieldset style="margin: 5px 0 0 0">
                                                    <legend>Dados do pedido</legend>
                                                    <div id="left-col">
                                                        <p><strong>Destino:</strong><br/>${agendamento.destino}</p>
                                                        <p class="line"></p>
                                                        <p><strong>Motivo da viagem:</strong><br/>${agendamento.motivo}</p>
                                                        <p class="line"></p>
                                                        <p><strong>Hora Consulta:</strong><br/>${agendamento.horario}</p>
                                                        <p class="line"></p>
                                                        <p><strong>Ponto:</strong><br/>${agendamento.ponto}</p>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">

                                            <div id="viagem">
                                                <div id="acompanhante">
                                                    <strong>ACOMPANHANTE(S):</strong>
                                                    <span id="agendamentoSpan">${agendamento.acompanhante}</span><br/><br/>
                                                    ${agendamento.comprovanteAcompanhante && agendamento.acompanhante1Nome ? `<b>ACOMPANHANTE 1</b><br/>
                                                    NOME: ${agendamento.acompanhante1Nome ?? ''}<br/>
                                                    ${agendamento.acompanhante1Cns ? `CNS: ${agendamento.acompanhante1Cns}<br/>` : ''}
                                                    ${agendamento.acompanhante1Telefone ?  `TELEFONE: ${agendamento.acompanhante1Telefone}<br/>` : ''}
                                                    RELAÇÃO: ${agendamento.acompanhante1Relacao ?? ''}` : ''}
                                                    ${agendamento.comprovanteAcompanhante && agendamento.acompanhante2Nome ? `<br/><br/><b>ACOMPANHANTE 2</b><br/>
                                                    NOME: ${agendamento.acompanhante2Nome ?? ''}<br/>
                                                    ${agendamento.acompanhante2Cns ? `CNS: ${agendamento.acompanhante2Cns}<br/>` : ''}
                                                    ${agendamento.acompanhante2Telefone ? `TELEFONE: ${agendamento.acompanhante2Telefone}<br/>` : ''}
                                                    RELAÇÃO: ${agendamento.acompanhante2Relacao ?? ''}</b>` : ""}
                                                </div>

                                                <div id="data-inicial">
                                                    <strong>DATA INICIAL:</strong><br />
                                                    <span id="agendamentoSpan">${agendamento.dataInicial}</span>
                                                </div>

                                                <div id="data-final">
                                                    <strong>DATA FINAL:</strong><br />
                                                    <span id="agendamentoSpan">${agendamento.dataFinal}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div id="obs">
                                                ${obs}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="report-content-cell">
                                            <div class="lineBottom"></div>

                                            <div>
                                                <div id="rodape-left">
                                                    <span id="sistemaNome"></span>
                                                    <span id="sistemaVersao"></span>
                                                </div>
                                                <div id="rodape-right">
                                                    <span>Impresso por: ${agendamento.usuario}</span><br/>
                                                    <span>Data/hora da impressão: ${date}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </body>
                    `)

                    page.document.getElementById('img').appendChild(image)
                    page.document.getElementById('prefeitura').innerHTML = prefeitura
                    page.document.getElementById('ramoAtividade').innerHTML = ramoAtividade
                    page.document.getElementById('sistemaNome').innerHTML = sistemaNome
                    page.document.getElementById('sistemaVersao').innerHTML = sistemaVersao

                    image.onload = function(){

                        page.print()
                        page.close()
                    }
                },
            }
        }
    },
}